import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import Text from '../../../ui/Text';
import Icon from '../../../ui/Icon';
import ComingSoon from './ComingSoon';
import AssignmentsBasedGradingOptIn from './AssignmentsBasedGradingOptIn';
import TeacherPacedModeOptIn from './TeacherPacedModeOptIn';

const BetaFeatures = ({
  active,
  displayAssignmentsBasedGradingOptIn,
  isAssignmentsBasedGradingActive,
  isTeacherPacedModeActive,
  setIsAssignmentsBasedGradingActive,
  setIsTeacherPacedModeActive,
  stafferPath
}) => {
  if (!active) return null;

  return (
    <div className="tw-mb-10">
      <ComingSoon displayNewsletter={!displayAssignmentsBasedGradingOptIn} />
      {displayAssignmentsBasedGradingOptIn && (
        <AssignmentsBasedGradingOptIn
          isAssignmentsBasedGradingActive={isAssignmentsBasedGradingActive}
          setIsAssignmentsBasedGradingActive={setIsAssignmentsBasedGradingActive}
          stafferPath={stafferPath}
        />
      )}
      <TeacherPacedModeOptIn
        isTeacherPacedModeActive={isTeacherPacedModeActive}
        setIsTeacherPacedModeActive={setIsTeacherPacedModeActive}
        stafferPath={stafferPath}
      />
      <hr />
      <Text italic size="sm">
        {I18n.t('beta_features_ai_blurb')}
        <a href="https://www.teachtci.com/tci-ai-approach/">
          <Icon className="tw-relative tw--top-px tw-ml-1 tw-align-middle" icon="ExternalLink" size={16} />
          {I18n.t('beta_features_ai_approach_link')}
        </a>
      </Text>
    </div>
  );
};

BetaFeatures.propTypes = {
  active: PropTypes.bool.isRequired,
  displayAssignmentsBasedGradingOptIn: PropTypes.bool.isRequired,
  isAssignmentsBasedGradingActive: PropTypes.bool.isRequired,
  isTeacherPacedModeActive: PropTypes.bool.isRequired,
  setIsAssignmentsBasedGradingActive: PropTypes.func.isRequired,
  setIsTeacherPacedModeActive: PropTypes.func.isRequired,
  stafferPath: PropTypes.string.isRequired,
};

export default BetaFeatures;
